export const isAvailableMonth = (availableDateMonth: number, currentMonth: number): boolean => {
  return availableDateMonth !== currentMonth - 1 && !(currentMonth - availableDateMonth === -11);
};
